<template>
  <v-card class="templateCard" @click.stop="select">
      <v-card-title class="d-flex align-center justify-space-between">
        #{{template.id}} {{template.name}} 
        <v-spacer></v-spacer> 
        <v-menu 
          offset-y 
          :close-on-content-click="false" 
          activator="parent" 
          v-model="choice">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop="toggleMenu"
            >
              <v-icon>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
            <v-list class="menu-list">
              <v-list-item @click="deleteTemplate(template)">
                <v-list-item-title>
                  Delete
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="previewTemplate(template)">
                <v-list-item-title>
                  Preview
                </v-list-item-title>
              </v-list-item>
            </v-list>
        </v-menu>
      </v-card-title>
      <v-card-text>
          {{template.description}}
      </v-card-text>
  </v-card>
</template>
 
<script>
  export default {
    name: 'Templates',
    props:{
        template : Object
    },
    data() {
      return {
        choice: false
      }
    },
    methods: {
        select(){
            this.$emit("selected",this.template);
        },
        deleteTemplate(){
          this.$emit("deleted",this.template);
        },
        previewTemplate(){
          this.$emit("previewed",this.template);
        },
        toggleMenu(){
          this.choice = !this.choice;
        }
    }
  }
</script>

<style>
    .templateCard {
        height: 100%
    }
    .v-list-item__title {
        margin-bottom: 13px !important;
    }
    .menu-list { 
      margin-left: 140px;
      margin-top: -10px; 
      width: 100px;
    }
    .v-chip{
    margin:4px;

    }
    @media print{
    v-main{
    padding:0px;
    }
  .v-timeline {
  padding-top:22px;
  }
    }
</style>
